export default {
  page: {
    title: 'Quebrar texto em linhas',
    subtitle: 'Ferramentas',
  },
  card: {
    title: 'Configuração da quebra',
  },
  form: {
    options: {
      title: 'Configurações padrão',
      removeAccents: 'Remover acentos',
      removeDuplicates: 'Remover duplicadas',
      sortAlphabetically: 'Ordenar lista',
      minWordLength: {
        label: 'Ignorar palavras com até:',
        unit: 'letras',
        tooltip:
          'Palavras com quantidade de letras igual ou menor que esse valor serão ignoradas.',
      },
    },
    text: {
      label: 'Texto:',
    },
    result: {
      label: 'Texto gerado:',
    },
    totalWords: {
      label: 'Total de palavras:',
    },
    ignored: {
      label: 'Ignoradas:',
    },
  },
  button: {
    download: 'Baixar',
  },
  alert: {
    noWordsFound:
      'Nenhuma palavra encontrada com mais de {count} letras.',
  },
};
